import AssetType from './AssetType';

const AssetTypeConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/assetTypes',
            element: <AssetType />,
        },
    ],
};

export default AssetTypeConfig;
